import { Divider, mergeClasses } from '@fluentui/react-components';
import {
  Building48Filled,
  CalendarLtr24Regular,
  Clock24Regular,
  Location24Regular,
} from '@fluentui/react-icons';
import { useTranslation } from 'react-i18next';
import { BasicButton, FeatureCard } from '@components/common';
import { useWelcomeSectionStyles } from './WelcomeSection.styles';

export interface WelcomeSectionProps {
  onStartNewRequest?: () => void;
  className?: string;
}

const featureCards = [
  {
    icon: <CalendarLtr24Regular />,
    titleKey: 'welcomeCard.bookSpaces.title',
    descriptionKey: 'welcomeCard.bookSpaces.description',
  },
  {
    icon: <Clock24Regular />,
    titleKey: 'welcomeCard.trackStatus.title',
    descriptionKey: 'welcomeCard.trackStatus.description',
  },
  {
    icon: <Location24Regular />,
    titleKey: 'welcomeCard.multipleLocations.title',
    descriptionKey: 'welcomeCard.multipleLocations.description',
  },
];

export const WelcomeSection = ({ onStartNewRequest, className }: WelcomeSectionProps) => {
  const styles = useWelcomeSectionStyles();
  const { t } = useTranslation('welcomeCard');

  return (
    <section aria-label={t('welcomeCard.title')} className={mergeClasses(styles.root, className)}>
      <span className={styles.icon} aria-hidden="true">
        <Building48Filled style={{ width: '4rem', height: '4rem' }} />
      </span>

      <h2 className={styles.title}>{t('welcomeCard.title')}</h2>

      <p className={styles.description}>{t('welcomeCard.description')}</p>

      <BasicButton
        variant="primary"
        size="medium"
        onClick={onStartNewRequest}
        className={styles.bookButton}
      >
        {t('welcomeCard.startNewRequest')}
      </BasicButton>

      <div className={styles.dividerWrapper}>
        <Divider />
      </div>

      <span className={styles.sectionLabel}>{t('welcomeCard.whatYouCanDo')}</span>

      <div className={styles.cardsRow}>
        {featureCards.map((card) => (
          <FeatureCard
            key={card.titleKey}
            icon={card.icon}
            title={t(card.titleKey)}
            description={t(card.descriptionKey)}
          />
        ))}
      </div>
    </section>
  );
};

WelcomeSection.displayName = 'WelcomeSection';
